import { useEffect } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import {
  SystemHealthTabs,
  SystemHealthTab,
} from '../../components/admin/systemHealth/SystemHealthTabs'
import { OverviewTab } from '../../components/admin/systemHealth/OverviewTab'
import { ServiceBusTab } from '../../components/admin/systemHealth/ServiceBusTab'
import { SelfTestSection } from '../../components/admin/selfTest/SelfTestSection'

// A lookup rather than a ternary chain, so adding a tab stays a one-line change.
const TAB_BODIES: Record<SystemHealthTab, () => JSX.Element> = {
  overview: OverviewTab,
  'service-bus': ServiceBusTab,
  endpoints: SelfTestSection,
}

const isValidTab = (tab: string | undefined): tab is SystemHealthTab =>
  tab !== undefined && tab in TAB_BODIES

export default function SystemHealthPage() {
  const { tab } = useParams<{ tab?: string }>()
  const navigate = useNavigate()

  const activeTab: SystemHealthTab = isValidTab(tab) ? tab : 'overview'
  const TabBody = TAB_BODIES[activeTab]

  // Tab state lives in the URL so a failing-endpoint view can be linked, and so
  // a refresh after a 45-second run does not silently land somewhere else.
  useEffect(() => {
    if (!isValidTab(tab)) {
      navigate('/system-health/overview', { replace: true })
    }
  }, [tab, navigate])

  return (
    <div className="space-y-6">
      <div className="border-b border-gray-200 pb-4">
        <h1 className="text-2xl font-bold text-gray-900">System Health</h1>
      </div>

      <SystemHealthTabs
        activeTab={activeTab}
        onTabChange={(next) => navigate(`/system-health/${next}`)}
      />

      <TabBody />
    </div>
  )
}
